// When moving to production, delete this file's usages in:
//   - src/App.js (the TestVersionBanner JSX block in render())
//   - src/App.js (the test warning row in createSheetHeader())
// Or simply set IS_TEST_VERSION = false to hide both without code removal.

export const IS_TEST_VERSION = false;

export const TEST_VERSION_BANNER_AR =
  '⚠ نسخة تجريبية (v2) — البيانات قد تكون غير دقيقة. لا تعتمد على هذا التقرير للأعمال الرسمية.';
